import React from "react";
import { store } from "../../../reducer/Store";
import { Card, Alert, Spinner } from "react-bootstrap";
import ApiService from "../../../services/ApiService";
import TableDynamic from "../../../components/TableDynamic";
import PlansListModal from "../../../components/planstrade/PlansListModal";
const PlansList = ({
  refreshTab,
  showAdd,
  setShowAdd,
  setShowDetailsPlan,
  setDetailsPlan,
  brand,
  setBrand,
}) => {
  const { dispatch, state } = React.useContext(store);
  const [showUpdate, setShowUpdate] = React.useState(false);
  const [namePlan, setNamePlan] = React.useState("");
  const [planId, setPlanId] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const columnsName = ["Nom du plan", "", ""];
  const columns = ["name", "brand", "updateAndDeletePlan"];
  const [noResultMessage, setNoResultMessage] = React.useState(false);
  const [dataPage, setDataPage] = React.useState([]);

  const handleClose = () => {
    setShowAdd(false);
    setShowUpdate(false);
    setDataPage([]);
    setNamePlan("");
    setBrand();
    setPlanId("");
    setErrorMessage("");
  };
  /**
   * Cette fonction met à jour les données d'un plan existant pour permettre l'affichage du formulaire de mise à jour de plan.
   * @param { Object } values - Les données actuelles du plan.
   * @param { Number } currentPage - La page courante de la liste de plans.
   * @param { Number } max - Le nombre maximum de plans par page.
   * @param { String } search - Le texte de recherche actuel dans la liste de plans.
   */
  const handleShowUpdate = (values, currentPage, max, search) => {
    var brandSelect = [];
    state.listBrands.filter((brand) =>
      brand.value === values.brand_id.toString() ? brandSelect.push(brand) : ""
    );
    setDataPage({ currentPage: currentPage, max: max, search: search });
    setNamePlan(values.name);
    setBrand(brandSelect);
    setPlanId(values.id);
    setErrorMessage("");
    setShowUpdate(true);
  };

  /**
   * Cette fonction effectue une requête asynchrone pour récupérer une liste de plans-trade en fonction des marques sélectionnées et de l'année en cours.
   * @param {number} page - Numéro de la page à récupérer (par défaut = 1).
   * @param {number} max - Nombre maximum de plans-trade à récupérer (par défaut = 25).
   */
  const getPlansTrade = async (page = 1, max = 25) => {

    //console.log('getPlansTrade');

    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `plans-by-brands-year-pagination/${brands}/${state.currentYear.value}?page=${page}&max=${max}`,
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        dispatch({ type: "SET_PLANSTRADELIST", payload: response.data });
        handleClose();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction recherche des plans commerciaux par une chaîne de caractères de recherche, une page et un nombre maximal d'éléments par page.
   * Elle met à jour la liste des plans commerciaux dans le store de l'application en fonction des critères de recherche et affiche un message si aucun résultat n'a été trouvé.
   * @param { String } search - La chaîne de caractères de recherche.
   * @param { Number } page - Le numéro de la page à afficher.
   * @param { Number } max - Le nombre maximal d'éléments à afficher par page.
   */
  const searchPlan = (search, page = 1, max = 25) => {
    dispatch({ type: "SET_LOADER", payload: true });
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    setNoResultMessage(false);
    ApiService.request(
      {
        search,
        page,
        max,
        brand_ids: brands.toString(),
        year_id: state.currentYear.value,
      },
      "plans-search-paginated",
      "post"
    )
      .then(function (response) {
        if (response.message === "No result.") {
          setNoResultMessage(true);
        } else {
          dispatch({
            type: "SET_PLANSTRADELIST",
            payload: response.data,
          });
        }
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        dispatch({ type: "SET_LOADER", payload: false });
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
        console.log(error);
      });
  };

  /**
   * Cette fonction ajoute un nouveau plan commercial pour la marque sélectionnée et l'année en cours.
   * Elle envoie une requête POST à l'API pour ajouter le plan commercial avec les informations fournies.
   * Si la requête réussit, la fonction ferme le formulaire d'ajout et ouvre la page de détails du plan commercial ajouté.
   * Si la requête échoue, la fonction affiche un message d'erreur et, en cas d'erreur d'authentification, redirige l'utilisateur vers la page de connexion.
   * @param { String } namePlan - Le nom du plan commercial à ajouter.
   * @param { Object } brand - L'objet de la marque sélectionnée contenant l'id et le nom de la marque.
   * @param { Number } year_id - L'année à laquelle rattacher le plan.
   */
  const addPlanTrade = async () => {
    setErrorMessage("");
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        name: namePlan,
        brand_id: brand.value,
        year_id: state.currentYear.value,
      },
      "plans",
      "post"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        handleClose();
        setDetailsPlan(response.data);
        setShowDetailsPlan(true);
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        setErrorMessage("Ce nom est déjà utilisé.");
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction met à jour les informations d'un type de PLV.
   * @param { String } namePlan - Le nouveau nom du type de PLV à mettre à jour.
   * @param { Object } brand - L'objet contenant l'identifiant de la marque associée au type de PLV à mettre à jour.
   * @param { String } planId - L'identifiant du type de PLV à mettre à jour.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   */
  const updatePlanTrade = async () => {
    setErrorMessage("");
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        name: namePlan,
        brand_id: brand[0].value,
        year_id: state.currentYear.value,
      },
      "plans/" + planId,
      "put"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        handleClose();
        dataPage.search && dataPage.search.length >= 3
          ? searchPlan(dataPage.search, dataPage.currentPage, dataPage.max)
          : getPlansTrade(dataPage.currentPage, dataPage.max);
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        setErrorMessage("Ce nom est déjà utilisé.");
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction permet de dupliquer un plan trade existant en envoyant une requête au serveur.
   * @param { Number } id - L'identifiant du plan trade à dupliquer.
   */
  const duplicatePlanTrade = async (id) => {
    setErrorMessage("");
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        id: id,
      },
      "plan-duplicate",
      "post"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        getPlansTrade();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        setErrorMessage("Ce nom est déjà utilisé.");
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction supprime un plan de PLV.
   * @param { Object } plan - L'objet plan de PLV à supprimer.
   */
  const deletePlanTrade = async (plan) => {
    if (
      window.confirm(
        "Voulez vous vraiment supprimer ce plan ? Cela est définitif."
      )
    ) {
      ApiService.request({}, "plans/" + plan.id, "delete")
        .then(function () {
          getPlansTrade();
        })
        .catch(function (error) {
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };


  // <JC

  const deletePlansTrade = (checkedIds) => {

    if (
      window.confirm(
        "Voulez vous vraiment supprimer ces plans ? Cela est définitif."
      )
    ) {

      dispatch({ type: "SET_LOADER", payload: true });
      ApiService.request(
        {
          ids: checkedIds
        },
        `plans-delete-bulk`,
        "post"
      )
        .then(function () {
          getPlansTrade();
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          console.log(error.response.data.message);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };
  
  // JC>


  React.useEffect(() => {
    if (state.currentBrands && state.currentBrands.length > 0) {
      getPlansTrade();
    } else {
      dispatch({ type: "SET_PLANSTRADELIST", payload: [] });
    }
  }, [state.currentBrands, state.currentYear, refreshTab]);

  const [formData] = React.useState({
    namePlan: namePlan || "",
    brand: brand || "",
  });
  const [newFormData, setNewFormData] = React.useState({
    ...formData,
  });
  const handleInputChange = (e, indexOrName = "") => {
    if (indexOrName === "brand") {
      setNewFormData({
        ...newFormData,
        brand: e,
      });
    } else {
      setNewFormData({
        ...newFormData,
        [e.target.name]: e.target.value,
      });
    }
  };
  const handleModalHide = () => {
    var windowConfirm = false;
    if (JSON.stringify(formData) !== JSON.stringify(newFormData)) {
      windowConfirm = true;
    }
    if (windowConfirm) {
      if (
        window.confirm(
          "Vous avez effectué des changements, êtes vous sûr de vouloir quitter sans valider ?"
        )
      ) {
        handleClose();
      }
    } else {
      handleClose();
    }
  };
  return (
    <>
      {showAdd && (
        <PlansListModal
          handleClose={handleClose}
          show={showAdd}
          addOrUpdatePlansList={addPlanTrade}
          errorMessage={errorMessage}
          setNamePlan={setNamePlan}
          handleInputChange={handleInputChange}
          handleModalHide={handleModalHide}
          setBrand={setBrand}
          namePlan={namePlan}
          brand={brand}
          brands={state.currentBrands}
          nameModal={"Ajouter"}
        />
      )}
      {showUpdate && (
        <PlansListModal
          handleClose={handleClose}
          show={showUpdate}
          addOrUpdatePlansList={updatePlanTrade}
          errorMessage={errorMessage}
          setNamePlan={setNamePlan}
          handleInputChange={handleInputChange}
          handleModalHide={handleModalHide}
          setBrand={setBrand}
          namePlan={namePlan}
          brand={brand}
          brands={state.currentBrands}
          nameModal={"Modifier"}
        />
      )}

      {state.currentBrands && state.currentBrands.length > 0 ? (
        state.plansListTrade ? (
          <TableDynamic
            controlTableId={"planslist"}
            columnsName={columnsName}
            columns={columns}
            data={state.plansListTrade.data}
            dataPagination={state.plansListTrade}
            showUpdate={handleShowUpdate}
            setShowDetailsPlan={setShowDetailsPlan}
            setDetailsPlan={setDetailsPlan}
            duplicatePlanOrCustomersList={duplicatePlanTrade}
            deleteD={deletePlanTrade}
            deleteDbulk={deletePlansTrade}
            setNoResultMessage={setNoResultMessage}
            noResultMessage={noResultMessage}
            search={searchPlan}
            getDataPagination={getPlansTrade}
          ></TableDynamic>
        ) : (
          <div className="text-center">
            <Spinner
              animation={state.loader ? "border" : false}
              role="status"
            ></Spinner>
          </div>
        )
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="danger" className="m-0">
              Veuillez sélectionner au moins une marque.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default PlansList;
